<template>
  <div class="supplier-detail">
    <div class="purchase-box">
      <el-button
        class="purchase-back"
        icon="icon-ccui-return"
        size="mini"
        type="primary"
        @click="purchaseBack"
        >返回</el-button
      >
      <div class="cut-line" />
      <!-- 面包屑 -->
      <el-breadcrumb
        class="purchase-crumbs"
        separator-class="el-icon-arrow-right"
      >
        <el-breadcrumb-item :to="{ path: '/#/zh-CN/component/breadcrumb' }"
          >审批中心</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/#/zh-CN/component/breadcrumb' }"
          >供应商</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/#/zh-CN/component/breadcrumb' }"
          >待办</el-breadcrumb-item
        >
        <el-breadcrumb-item>嘉兴友朋注册申请</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="detail-box">
      <div class="detail-info">
        <div class="details-contract">
          <div class="contract-content">
            <!--审批状态 icon-->
            <div class="content-el-Label">
              <div class="el-Label">
                <el-label v-if="labelTypeadopt" :type="approvalStatus" />
                <el-label v-if="labelTypeapproval" :type="approvalStatus2" />
                <el-label v-if="labelTypenotpass" :type="approvalStatus3" />
              </div>
            </div>
            <div class="details-contract">
              <el-detail-info
                :title-message="titleMessage"
                :info-title="infoTitle"
                :info-content="infoContent"
              />
            </div>
            <!--产品信息-->
            <el-card-title :title="title1" />
            <div class="contract-title-from">
              <el-table
                :data="tableData"
                :header-cell-style="{ background: '#ffffff', color: '#4A4A4A' }"
                border
                lazy
                row-key="id"
                style="width: 100%"
              >
                <el-table-column label="序号" prop="id" width="" />
                <el-table-column label="产品编码" prop="name" width="" />
                <el-table-column label="产品名称" prop="name1" width="" />
                <el-table-column label="厂商或品牌" prop="type" width="" />
                <el-table-column label="备注" prop="address" width="" />
              </el-table>
            </div>
            <!--联系人信息-->
            <el-card-title :title="title2" />
            <div class="contract-title-from">
              <el-table
                :data="activities3"
                :header-cell-style="{ background: '#ffffff', color: '#4A4A4A' }"
                border
                lazy
                row-key="id"
                style="width: 100%"
              >
                <el-table-column label="序号" prop="id" width="50" />
                <el-table-column
                  label="联系人分类"
                  prop="联系人分类"
                  width=""
                />
                <el-table-column label="姓名" prop="姓名" width="100" />
                <el-table-column label="手机号" prop="手机号" width="" />
                <el-table-column label="固定电话" prop="固定电话" width="" />
                <el-table-column label="传真电话" prop="传真电话" width="" />
                <el-table-column label="邮箱" prop="邮箱" width="" />
              </el-table>
            </div>
            <!--财务信息-->
            <el-card-title :title="title3" />
            <div class="contract-title-from">
              <el-table
                :data="activities4"
                :header-cell-style="{ background: '#ffffff', color: '#4A4A4A' }"
                border
                lazy
                row-key="id"
                style="width: 100%"
              >
                <el-table-column label="序号" prop="id" width="50" />
                <el-table-column label="开户银行" prop="开户银行" width="" />
                <el-table-column label="银行账号" prop="银行账号" width="" />
                <el-table-column label="开票地址" prop="开票地址" width="" />
                <el-table-column label="开票电话" prop="开票电话" width="" />
              </el-table>
            </div>
            <!--资质文件-->
            <el-card-title :title="title5" />
            <div class="contract-title-from1">
              <el-table
                :data="activities5"
                :header-cell-style="{ background: '#ffffff', color: '#4A4A4A' }"
                border
                lazy
                row-key="id"
                style="width: 100%"
              >
                <el-table-column label="序号" prop="id" width="50" />
                <el-table-column label="附件名称" prop="" width="100">
                  <template slot-scope="scope">
                    <div class="box">
                      <svg
                        id="Layer_1"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        width="24px"
                        height="24px"
                        viewBox="0 0 44 44"
                        enable-background="new 0 0 44 44"
                        xml:space="preserve"
                      >
                        <image
                          id="image0"
                          width="44"
                          height="44"
                          x="0"
                          y="0"
                          href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAA+VBMVEXw8PDbNi7bNy/v7+/r
zcvpt7Xqvbvs1NLv6uridnHZJh3aLiXjgn3t4+LaNCvfXlffVlDbOjLfZV7eWlPv7u7jfHfqw8Hs
2NfZKB/moJzt5OPaLSTlmJTmnprqurjcQDnkj4rkhoLgaGLZKyLeS0TeVU7s0dDcPzfkjIjmpKDq
xcPfSULjY1zgT0jhVU7jYVvbMSndPDTeRz/vo6DofHfphoHtmpb0xMHlbmjmdW/neHLkamPfSkPl
b2nndXDun5vzvrvZJx7yubbytLHrko3gUkvphH/iX1jaLybxr6zne3XcPDTdQDj1yMbwqqfwqabg
U0vla2X///9Mbax+AAAAA3RSTlPq/f08HYD5AAAAAWJLR0RSDWAtkAAAAAd0SU1FB+MFFgAFHmbu
jZkAAADJSURBVDjLY2BgJhowkKAWqHpUMfUUs7CCABs7BzGKObkggJuHlxjFfPz8/AKCXFxCxCgW
BlEiolxcYsQqZhaX4JIkWrGUNJcM0YplubjkiFAsr6CgoKikzKXCQYRiKFBVIyY01BUVFTU0tTBk
8LiZebgqxgNGFZOvmIsEQEfF2jq6XHr6BlyGOjpGBBUbm5iamVsYW1qZWdsQVmxrZ+/A5ehk5ezi
Slixm7uyA5eHp5WXtwdhxT5cXL5+/gFWgQMadHgVMxKvlgkAdtg0r8oYKTsAAAAldEVYdGRhdGU6
Y3JlYXRlADIwMTktMDUtMjFUMTY6MDU6MzArMDg6MDAANEsAAAAAJXRFWHRkYXRlOm1vZGlmeQAy
MDE5LTA1LTIxVDE2OjA1OjMwKzA4OjAwcWnzvAAAAABJRU5ErkJggg=="
                        />
                      </svg>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="" prop="name" width="" />
                <el-table-column fixed="right" label="操作" width="170">
                  <template slot-scope="scope" style="margin-top: -11px">
                    <el-button size="mini" type="text">下载</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!--历史记录-->
            <div class="contract-detail-histor">
              <el-history-list :message="message" />
            </div>
          </div>
        </div>
      </div>
      <!--右边审批状态-->
      <div class="detail-react">
        <div class="timeline-approval-block">
          <div class="detail-title">
            <div class="approval-process">
              <el-button
                :class="[isFocus ? 'active disposal' : '']"
                size="medium"
                type="text"
                @click="handleDisposal"
                >审批记录
              </el-button>
              <el-button
                :class="[isFocus ? 'processed' : 'active processed']"
                size="medium"
                type="text"
                @click="handleProcessed"
              >
                <span class="process">阅读记录</span>
              </el-button>
            </div>
          </div>
          <div class="el-timeline-approval">
            <div v-if="reading" class="timeline-approval-block">
              <el-timeline>
                <el-timeline-item
                  v-for="(activity, index) in activities2"
                  :color="activity.color"
                  :icon="activity.icon"
                  :key="index"
                  :size="activity.size"
                  :timestamp="activity.date"
                  :type="activity.type"
                >
                  <div class="contentCatamp">
                    <div class="timeline-approval-blockImg">
                      <i class="icon-ccui-user" />
                    </div>
                    <div class="contentCatamp_contentCat">
                      <span class="contentCat">{{ activity.name }}</span>
                      <span class="contentCategory" style="margin-left: 6px">{{
                        activity.weekCount
                      }}</span>
                    </div>
                    <div class="contentCategory_details">
                      {{ activity.weekAmount }}
                    </div>
                  </div>
                  <div class="opinionSize">
                    <span class="contentCategory">{{
                      activity.conclusion
                    }}</span>
                    <span :class="conclusion">{{
                      activity.conclusionResult
                    }}</span>
                  </div>
                  <div class="opinionSize">
                    <span class="contentCategory">{{ activity.opinion }}</span>
                    <span class="opinion">{{ activity.opinionstate }}</span>
                  </div>
                </el-timeline-item>
              </el-timeline>
            </div>
            <div v-if="reading1" class="readingRecords">
              <el-table :data="tableDatar" style="width: 100%">
                <el-table-column prop="id" label="序号" width="85" />
                <el-table-column prop="name" label="姓名" width="" />
                <el-table-column prop="date" label="阅读日期" />
              </el-table>
            </div>
          </div>
        </div>
      </div>
      <!--相关信息-->
      <div class="detail-relevant">
        <div class="detail-title">
          <el-card-title :title="title4" />
          <div>相关订单</div>
          <div>相关需求</div>
        </div>
      </div>
    </div>
    <div class="detail-bottom">
      <ul class="detail-bottom-center">
        <li>
          <el-button icon="icon-ccui-return" type="bottom" @click="purchaseBack"
            >返回</el-button
          >
        </li>
        <div class="bottom-center-solid" />
        <li>
          <el-button icon="icon-ccui-edit" type="bottom" @click="supplierDdit"
            >编辑</el-button
          >
        </li>
        <li>
          <el-button icon="icon-ccui-agree" type="bottom">同意</el-button>
        </li>
        <li>
          <el-button icon="icon-ccui-disagree" type="bottom">不同意</el-button>
        </li>
        <li>
          <el-button icon="icon-ccui-reject" type="bottom">退回</el-button>
        </li>
        <li>
          <el-button icon="icon-ccui-transfer" type="bottom">转审</el-button>
        </li>
        <li>
          <el-button icon="icon-ccui-jointly" type="bottom">协办</el-button>
        </li>
        <li>
          <el-button icon="icon-ccui-notify" type="bottom">知会</el-button>
        </li>
        <div class="bottom-center-solid-two" />
        <li>
          <el-button icon="icon-ccui-export" type="bottom">导出</el-button>
        </li>
        <li>
          <el-button icon="icon-ccui-copy" type="bottom">复制</el-button>
        </li>
        <li>
          <el-button icon="icon-ccui-print" type="bottom">打印</el-button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import { getList } from "@/api/supplier-detail";

export default {
  name: "Pascalcase",
  data() {
    return {
      pageNo: 4,
      pageSize: 10,
      type: null,
      conclusion: "",
      approvalStatus: "approvaled",
      approvalStatus2: "approving",
      approvalStatus3: "unapproval",
      isFocus: true,
      labelTypeadopt: false,
      labelTypeapproval: false,
      labelTypenotpass: false,
      reading: true,
      reading1: false,
      title: "基本信息",
      title1: "产品信息",
      title2: "联系人信息",
      title3: "财务信息",
      title4: "相关信息",
      title5: "资质文件",
      titleMessage: {
        title: "基本信息"
      },
      infoTitle: [
        {
          label: "供方名称(中文)：",
          titleContent: "武汉佳兴友朋科技有限公司"
        },
        {
          label: "成立时间：",
          titleContent: "2016-09-29"
        },
        {
          label: "所在地区：",
          titleContent: "武昌区友谊路34号江铃社区"
        },
        {
          label: "营业期限：",
          titleContent: "2016-09-29至2026-09-28"
        },
        {
          label: "注册资本(万元)：",
          titleContent: "500万"
        },
        {
          label: "币种：",
          titleContent: "人民币"
        },
        {
          label: "公司类型：",
          titleContent: "有限责任公司(自然人投资或控股)"
        },
        {
          label: "员工人数：",
          titleContent: "6"
        },
        {
          label: "统一社会信用代码：",
          titleContent: "91420111MA4"
        },
        {
          label: "注册联系人电话：",
          titleContent: "18543216789"
        },
        {
          label: "工商注册号：",
          titleContent: "42011100051321"
        },
        {
          label: "组织机构代码：",
          titleContent: "MA4KNMBJ3"
        },
        {
          label: "税号：",
          titleContent: "91420111MA4KNMBJ3"
        }
      ],
      tableDatar: [],
      infoContent: {
        title: "合同条款：",
        clause: [
          "甲方中途退货，应该向乙方偿付退货部分贷款%（通用产品的涨幅为1%~5%,专用产品的涨幅为15%~30%）的违约金。",
          "甲方自提产品未按供方通知的日期或合同日期提货的，应比照中国人民银行有关延期付款规定，按预期提货部分贷款总值计算，向乙方偿付逾期提货的违约金，并承担乙方实际支付的代为保管、保养的费用。",
          "甲方逾期付款的，应按照中国人民银行有关延期付款的规定向乙方偿付逾期付款的违约金",
          "甲方违反合同规定拒绝接货的，应当承担由此造成的损失和运输部门的罚款",
          "甲方如错填到货地点和接货人，或对乙方提出错误异议，应承担乙方因此所受的损失"
        ]
      },
      tableData: [],
      message: [
        {
          id: 1,
          name: "王维",
          time: "2019-01-01",
          type: 1,
          desc: [
            {
              info: "我是描述信息1"
            },
            {
              info: "修改了经营范围 ，旧值为 “产品的开发”，新值为 “产品开发”。"
            }
          ],
          isshow: false
        },
        {
          id: 2,
          name: "刘忻",
          time: "2013-01-01",
          type: 2,
          desc: [
            {
              info: "我是描述信息1"
            },
            {
              info: "我是描述信息2"
            }
          ],
          isshow: false
        }
      ],
      activities2: [], // 右边审批详情数据
      activities3: [], // 联系人信息数据
      activities4: [], // 财务信息数据
      activities5: [] // 资质文件数据
    };
  },
  created() {
    this.getList();
  },
  activated() {},
  methods: {
    handleDisposal() {
      this.isFocus = true;
      this.reading = true;
      this.reading1 = false;
    },
    handleProcessed() {
      this.isFocus = false;
      this.reading = false;
      this.reading1 = true;
      this.getList1();
    },
    purchaseBack() {
      this.$router.push({ path: "/approval/supplier/supplier-list" });
    },
    supplierDdit() {
      this.$router.push({ path: "/approval/supplier/new-supplier" });
    },
    getList() {
      this.tableData = [];
      const obj = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        isShowLoading: true,
        data: { ...this.formLabelAlign }
      };
      getList(obj).then(res => {
        const uu = res.data.data; // 产品信息id
        const uuu = res.data.contactInfor; // 联系人信息id
        const uuuu = res.data.finance; // 财务信息id
        for (let y = 0; y < uu.length; y++) {
          if (uu[y].id < 10) {
            uu[y].id = "0" + uu[y].id;
          }
        }
        for (let y = 0; y < uuu.length; y++) {
          if (uuu[y].id < 10) {
            uuu[y].id = "0" + uuu[y].id;
          }
        }
        for (let y = 0; y < uuuu.length; y++) {
          if (uuuu[y].id < 10) {
            uuuu[y].id = "0" + uuuu[y].id;
          }
        }
        this.type = res.data.type;
        this.tableData = res.data.data;
        this.activities2 = res.data.monthAmount; // 右边审批详情数据
        this.activities3 = res.data.contactInfor; // 联系人信息数据
        this.activities4 = res.data.finance; // 财务信息数据
        this.activities5 = res.data.qualifications; // 资质文件数据
        let timeline_icon1 = ""; // eslint-disable-line no-unused-vars
        let timeline_color = ""; // eslint-disable-line no-unused-vars
        if (res.data.type === 0) {
          timeline_color = "#0bbd87";
          timeline_icon1 = "icon-ccui-check";
          this.conclusion = "conclusion";
          this.opinion = "opinion";
          this.labelTypeadopt = true;
          const data = this.activities2;
          for (let i = 0; i < data.length; i++) {
            data[0].opinionstate = res.data.monthCount;
          }
        }
        if (res.data.type === 1) {
          timeline_color = "#F5A623";
          timeline_icon1 = "icon-ccui-clock";
          this.labelTypeapproval = true;
          this.conclusion = "conclusion";
          const data = this.activities2;
          for (let i = 0; i < data.length; i++) {
            data[data.length - 1].conclusion = "";
            data[data.length - 1].conclusionResult = "";
            data[data.length - 1].opinion = "";
            data[data.length - 1].opinionstate = "审批中";
            data[0].opinionstate = res.data.monthCount;
          }
        }
        if (res.data.type === 2) {
          timeline_icon1 = "icon-ccui-warn";
          timeline_color = "#D40A0A";
          this.conclusion = "conclusion1";
          this.labelTypenotpass = true;
          this.opinion = "opinion";
          const data = this.activities2;
          for (let i = 0; i < data.length; i++) {
            data[i].conclusionResult = "审批不通过";
          }
        }
        const data = this.activities2;
        for (var i = 0; i < data.length; i++) {
          data[data.length - 1].icon = timeline_icon1;
          data[data.length - 1].color = timeline_color;
          data[0].opinion = "说明：";
          data[0].weekCount = "(申请人)";
          data[0].conclusion = "";
          data[0].conclusionResult = "";
          data[0].opinionstate =
            "安全帽样式价格已确定，合同已经拟好，请领导审批";
        }
      });
    },
    getList1() {
      const obj = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        isShowLoading: true,
        data: { ...this.formLabelAlign }
      };
      getList(obj).then(res => {
        this.tableDatar = res.data.tableDatar;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  list-style: none;
}
.contract-title-from {
  padding: 20px;
  .el-table {
    /deep/ tr {
      height: 40px;
    }
    /deep/ th {
      padding: 8px 0;
      font-size: 13px;
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      color: rgba(74, 74, 74, 1);
      line-height: 18px;
      border-right: none;
    }
    /deep/ .el-table__row {
      height: 36px;
      td {
        font-size: 13px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(74, 74, 74, 1);
        line-height: 18px;
        border-right: none;
      }
      tr > td:nth-child(3) {
        .cell {
          margin-left: -72px;
        }
      }
    }
  }
}
.contract-title-from1 {
  padding: 20px;
  .el-table {
    /deep/ .el-table__fixed-right {
      border-right: 1px solid #ebeef5;
    }
    /deep/ tr {
      height: 40px;
    }
    /deep/ th {
      padding: 0;
      font-size: 13px;
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      color: rgba(74, 74, 74, 1);
      line-height: 18px;
      border-right: none;
    }
    /deep/ .el-table_4_column_21 {
      .cell {
        padding: 0;
        span {
          font-size: 13px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(85, 118, 207, 1);
        }
      }
    }
    /deep/ .el-table__row {
      height: 36px;
      td {
        font-size: 13px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(74, 74, 74, 1);
        border-right: none;
        border-bottom: none;
        padding: 0;
      }
    }
    /deep/ .el-table__row > td:nth-child(3) {
      .cell {
        margin-left: -72px;
      }
    }
  }
}
.contract-detail-histor {
  /deep/ .el-history-list {
    .header {
      height: 22px;
      margin-bottom: 15px;
      .header-baseline {
        margin-top: -5px;
        .isShowBtn-l1 {
          width: 18px;
          height: 18px;
          margin: 0 7px 0 16px;
        }
        .isShowBtn-open {
          width: 18px;
          height: 18px;
          margin-top: 0;
        }
      }
    }
    /deep/ .dataList {
      font-size: 13px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(74, 74, 74, 1);
    }
    /deep/ .history-tree {
      .data-list {
        .isShowBtn-open {
          width: 18px;
          height: 18px;
          margin-top: 0;
        }
      }
      li {
        margin-left: 22px !important;
      }
      li:last-child {
        margin-left: 23px !important;
      }
    }
  }
}
.detail-react {
  .timeline-approval-block {
    border: none;
    .approval-process {
      .el-button {
        color: #9b9b9b;
        font-weight: 500;
      }
      .processed {
        margin-left: 23px;
      }
      .active {
        color: #004898;
        border-bottom: 2px solid rgba(7, 91, 186, 1);
        border-radius: 0;
        font-weight: 600;
        font-size: 14px;
      }
      .el-button--medium {
        padding: 0 0 3px 0;
      }
      .process {
        font-size: 14px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
      }
    }
    .el-timeline {
      padding: 20px 34px 20px 23px;
      /deep/ .el-timeline-item {
        padding-bottom: 40px;
        /deep/ .opinionSize {
          margin-top: 6px !important;
        }
        .el-timeline-item__tail {
          top: 10px;
        }
        .el-timeline-item__node {
          top: 10px;
        }
      }
      /deep/ .el-timeline-item:last-child {
        padding-bottom: 0;
      }
      /deep/ .contentCatamp_contentCat {
        .contentCategory {
          font-size: 13px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
        }
      }
      /deep/ .contentCategory_details {
        font-size: 12px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(155, 155, 155, 1);
        line-height: 17px;
      }
      /deep/ .contentCategory {
        font-size: 13px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(155, 155, 155, 1);
      }
      /deep/ .opinion {
        font-size: 13px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: #4a4a4a;
      }
      /deep/ .conclusion1 {
        font-size: 13px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: #d5090b;
      }
      /deep/ .conclusion {
        font-size: 13px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: #009588;
      }
      /deep/ .el-timeline-item__timestamp {
        font-size: 12px;
        right: 4px;
      }
    }
  }
  .readingRecords {
    width: 335px;
    background: red;
    margin: 20px 22px 20px 24px;
    /deep/ .el-table__header-wrapper {
      thead {
        tr {
          th {
            padding: 8px 0 7px 0;
            border-right: 1px solid #f1f1f1;
            border-top: 1px solid #d8d8d8;
            border-bottom: 1px solid #d8d8d8;
            .cell {
              font-size: 13px;
              font-family: PingFangSC-Semibold;
              font-weight: 600;
              color: rgba(74, 74, 74, 1);
            }
          }
          th:last-child {
            border-right: none;
          }
        }
      }
    }
    /deep/ .el-table__body-wrapper {
      tbody {
        tr {
          td {
            border-right: 1px solid #f1f1f1;
            .cell {
              font-size: 13px;
              font-family: PingFangSC-Regular;
              font-weight: 400;
              color: rgba(74, 74, 74, 1);
            }
          }
          td:last-child {
            border-right: none;
          }
        }
      }
    }
  }
}
.main-wrapper {
  width: 100%;
}

.detail-info {
  width: calc(100% - 395px);
  height: 100%;
  float: left;
  background: #fff;
}

.contract-content {
  position: relative;
  overflow: hidden;
  .content-el-Label {
    position: absolute;
    width: 107px;
    right: 33px;
    top: 16px;
    z-index: 1;
    overflow: hidden;
  }
  .contract-detail-histor {
    padding: 0 20px;
  }
  /deep/ .el-card-title {
    height: 21px;
    margin: 0 20px;
    .details-title {
      top: 0;
    }
  }
}

.contract-title {
  float: left;
  width: 100% !important;
  height: 100% !important;
  margin-top: 8px;
}

.box {
  width: 24px;
  height: 24px;
  margin-top: 6px;
}
.contract-title > div {
  width: 50% !important;
}

.el-table_1_column_6 > cell {
  text-align: center;
}

.detail-enclosure {
  margin-left: -39px;
}

.detail-enclosure > li {
  float: left;
  width: 15%;
  height: 36px;
  line-height: 36px;
  font-size: 13px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: #4a4a4a;
}

.detail-enclosure > li:first-child {
  width: 7%;
}

.detail-enclosure > li:nth-of-type(2) {
  width: 30%;
}

.detail-react {
  width: 380px;
  float: left;
  margin-left: 15px;
  background: #fff;
}

.details-contract {
  width: 100%;
}

.timeline-approval-blockImg > i:first-child {
  font-size: 26px;
  color: #fff;
  position: absolute;
  left: 2px;
  bottom: -1px;
}

.detail-box {
  width: 100%;
}

@media screen and (max-width: 1438px) {
  .detail-info {
    width: 781px;
  }
  .detail-bottom-center {
    width: 92% !important;
  }
  .detail-info {
    width: 781px;
  }
}
.detail-title {
  margin: 0 20px;
  /deep/ .el-card-title {
    .details-title {
      top: 0;
    }
  }
  .approval-process {
    margin-top: 16px;
  }
}

.detail-relevant {
  width: 380px;
  height: 129px;
  background: #fff;
  float: left;
  margin: 15px 0 0 15px;
  .detail-title > div {
    margin-left: 4px;
    font-size: 13px;
    color: #4a4a4a;
    margin-top: 16px;
  }
  .detail-title > div:first-child {
    height: 21px;
    margin: 20px 0 0 0;
  }
}

.detail-bottom {
  width: 100%;
  height: 40px;
  background: #9e9e9e !important;
  float: left;
  margin-top: 20px;
  margin-bottom: 20px;
  background: rgba(76, 76, 76, 0.5);

  .detail-bottom-center {
    width: 81%;
    height: 40px;
    margin: 0 auto;
    /deep/ .el-button--bottom {
      span {
        font-size: 13px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
      }
    }
    /deep/ .icon-ccui-return {
      font-size: 18px !important;
    }
    .el-button {
      /deep/ i {
        float: left;
      }
      /deep/ .icon-ccui-return {
        display: inline-block;
        font-size: 14px;
      }
    }
  }
}

.detail-bottom-center > li {
  float: left;
  margin-left: 5px;
  line-height: 40px;
}

.el-button--bottom {
  border: none !important;
}

.bottom-center-solid {
  width: 1px;
  height: 20px;
  background: rgba(196, 196, 196, 1);
  border-radius: 1px;
  float: left;
  margin: 10px 40px 0 40px;
}
.bottom-center-solid-two {
  width: 1px;
  height: 20px;
  background: rgba(196, 196, 196, 1);
  border-radius: 1px;
  float: left;
  margin: 10px 40px 0 40px;
}
label {
  width: 278px;
  height: 18px;
  font-size: 13px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
  line-height: 18px;
}
.purchase-box {
  margin: 0 0 21px 0 !important;
  /deep/ .purchase-back {
    width: 70px;
    font-size: 14px;
    padding: 6px 9px;
    /deep/ .icon-ccui-return {
      font-size: 16px;
      margin-right: 8px;
      float: left;
    }
    span {
      display: block;
      margin-top: -6px;
    }
  }
}
.el-breadcrumb.purchase-crumbs {
  line-height: 30px;
}
.purchase-back {
  float: left;
}
.cut-line {
  width: 1px;
  height: 21px;
  background: rgba(216, 216, 216, 1);
  float: left;
  margin: 5px 20px 0 20px;
}
.details-contract {
  .contract-content {
    .details-contract {
      overflow: hidden;
      margin-bottom: 14px;
      /deep/ label {
        font-family: PingFangSC-Regular;
        font-weight: 400;
      }
      /deep/ .el-detail-info {
        overflow: hidden;
        .el-card-title {
          height: 21px;
          margin-top: 20px;
        }
        .info-title {
          padding-top: 25px;
          margin: 0 25px;
          .info-title-message {
            margin-bottom: 20px;
          }
        }
        /deep/ .infoTitle {
          .el-row {
            margin: 0 !important;
          }
        }
        .infoContent {
          li {
            text-indent: 0;
          }
        }
      }
    }
  }
}
</style>
